export class MipFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getPests(filters) {
    return this.instance.get(`/v1/pests`, {
      params: filters || null,
    });
  }

  insertPest(data) {
    return this.instance.post(`/v1/pests`, data, {
      timeout: 120000,
    });
  }

  updatePest(id, data) {
    return this.instance.put(`/v1/pests/${id}`, data, {
      timeout: 120000,
    });
  }

  deletePest(id) {
    return this.instance.delete(`/v1/pests/${id}`);
  }

  getPoints(filters) {
    return this.instance.get(`/v1/mip`, {
      params: filters || null,
    });
  }

  getTotals(filters) {
    return this.instance.get(`/v1/mip/level-count`, {
      params: filters || null,
    });
  }

  getDashboard(filters) {
    return this.instance.get(`/v1/mip/dashboard`, {
      params: filters || null,
    });
  }

  getPointsDetails(filters) {
    return this.instance.get(`/v1/mip/details`, {
      params: filters || null,
    });
  }

  getPoint(id) {
    return this.instance.get(`/v1/mip/${id}`);
  }

  createPoint(data) {
    return this.instance.post(`/v1/mip`, data);
  }

  updatePoint(id, data) {
    return this.instance.put(`/v1/mip/${id}`, data);
  }

  deletePoint(id) {
    return this.instance.delete(`/v1/mip/${id}`);
  }

  getConfig() {
    return this.instance.get(`/v1/mip/config`);
  }

  updateConfig(data) {
    return this.instance.put(`/v1/mip/config`, data);
  }

  listSessionsByDate(date) {
    return this.instance.get(`/v1/mip/sessions`, {
      params: { date },
    });
  }

  getActiveSession(talhaoId) {
    return this.instance.get(`/v1/mip/sessions/active`, {
      params: { talhaoId },
    });
  }

  getSessionDetail(id) {
    return this.instance.get(`/v1/mip/sessions/${id}`);
  }

  createSession(data) {
    return this.instance.post(`/v1/mip/sessions`, data);
  }

  finishSession(id, data) {
    return this.instance.put(`/v1/mip/sessions/${id}/finish`, data || {});
  }

  updateSession(id, data) {
    return this.instance.put(`/v1/mip/sessions/${id}`, data);
  }

  deleteSession(id) {
    return this.instance.delete(`/v1/mip/sessions/${id}`);
  }
}

export default MipFactory;
